import React from 'react';
import './Correlation.css';

// Import the new chart image
import correlationImage from '../../assets/images/correlation-chart.png';

const Correlation = () => {
  return (
    <section className="correlation-section">
      <div className="correlation-container">
        {/* Left Column: Image */}
        <div className="correlation-image-col">
          <img src={correlationImage} alt="Correlation analysis of price influencing factors" />
        </div>

        {/* Right Column: Text Content */}
        <div className="correlation-text-col">
          <h3>Key drivers behind every forecast</h3>
          <p>
            Each forecast includes a breakdown of key influencing factors making the logic behind price shifts transparent and helping you in the decision-making process.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Correlation;